import { Navigate } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { Loader2 } from 'lucide-react';
import { useMySchoolMembership } from '@/hooks/useSchoolApi';
import { toast } from '@/hooks/use-toast';

interface SchoolRouteProps {
  children: React.ReactNode;
}

export function SchoolRoute({ children }: SchoolRouteProps) {
  const { data: membership, isLoading } = useMySchoolMembership();
  // FIX-R38-MED: only fire the toast once per redirect, not on every render
  // while the redirect is mid-flight.
  const toastedRef = useRef(false);

  useEffect(() => {
    if (!isLoading && !membership && !toastedRef.current) {
      toastedRef.current = true;
      toast({
        title: 'School membership required',
        description: 'You need a school membership to access this area.',
      });
    }
  }, [isLoading, membership]);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!membership) {
    return <Navigate to="/passport" replace />;
  }

  return <>{children}</>;
}
